import { MotifSearch } from "@ey-xd/motif-react";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function debounceInput(fn: any, delay: number) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  let timer: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return function (this: any, ...args: any) {
    clearTimeout(timer);
    timer = setTimeout(() => {
      fn.apply(this, args);
    }, delay);
  };
}

// Define Props type
type Props = {
  id?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onChange?: (e: any) => void;
  value?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [key: string]: any; // Allow additional props
  clearSearch?: () => void;
};

export default function SearchInput({
  id,
  onChange,
  value,
  withOutDebounce,
  clearSearch,
  ...props
}: Props & { withOutDebounce?: boolean }) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const handleChange = debounceInput((e: any) => {
    if (onChange) {
      onChange(e);
    }
  }, 500);
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const handleChangeWithOutDebounceEffect = (e: any) => {
    if (onChange) {
      onChange(e);
    }
  };

  return (
    <MotifSearch
      id={id}
      {...props}
      onChange={
        withOutDebounce ? handleChangeWithOutDebounceEffect : handleChange
      }
      value={value}
      autoComplete="off"
      onClear={clearSearch}
    />
  );
}
